/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The TenantSmsMessage model module.
 * @module model/TenantSmsMessage
 * @version v0.3
 */
export default class TenantSmsMessage {
  /**
   * Constructs a new <code>TenantSmsMessage</code>.
   * @alias module:model/TenantSmsMessage
   * @class
   * @param enrolledDate {Date}
   */
  constructor(enrolledDate) {
    this.enrolledDate = enrolledDate;
  }

  /**
   * Constructs a <code>TenantSmsMessage</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TenantSmsMessage} obj Optional instance to populate.
   * @return {module:model/TenantSmsMessage} The populated <code>TenantSmsMessage</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TenantSmsMessage();
      if (data.hasOwnProperty('sid'))
        obj.sid = ApiClient.convertToType(data['sid'], 'String');
      if (data.hasOwnProperty('account_sid'))
        obj.accountSid = ApiClient.convertToType(data['account_sid'], 'String');
      if (data.hasOwnProperty('from'))
        obj.from = ApiClient.convertToType(data['from'], 'String');
      if (data.hasOwnProperty('to'))
        obj.to = ApiClient.convertToType(data['to'], 'String');
      if (data.hasOwnProperty('body'))
        obj.body = ApiClient.convertToType(data['body'], 'String');
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'String');
      if (data.hasOwnProperty('date_sent'))
        obj.dateSent = ApiClient.convertToType(data['date_sent'], 'String');
      if (data.hasOwnProperty('patient_id'))
        obj.patientId = ApiClient.convertToType(data['patient_id'], 'String');
      if (data.hasOwnProperty('patient_name'))
        obj.patientName = ApiClient.convertToType(data['patient_name'], 'String');
      if (data.hasOwnProperty('referred_patient_id'))
        obj.referredPatientId = ApiClient.convertToType(data['referred_patient_id'], 'String');
      if (data.hasOwnProperty('referred_patient_name'))
        obj.referredPatientName = ApiClient.convertToType(data['referred_patient_name'], 'String');
      if (data.hasOwnProperty('enrolled_date'))
        obj.enrolledDate = ApiClient.convertToType(data['enrolled_date'], 'Date');
    }
    return obj;
  }
}

/**
 * @member {String} sid
 */
TenantSmsMessage.prototype.sid = undefined;

/**
 * @member {String} accountSid
 */
TenantSmsMessage.prototype.accountSid = undefined;

/**
 * @member {String} from
 */
TenantSmsMessage.prototype.from = undefined;

/**
 * @member {String} to
 */
TenantSmsMessage.prototype.to = undefined;

/**
 * @member {String} body
 */
TenantSmsMessage.prototype.body = undefined;

/**
 * @member {String} status
 */
TenantSmsMessage.prototype.status = undefined;

/**
 * @member {String} dateSent
 */
TenantSmsMessage.prototype.dateSent = undefined;

/**
 * @member {String} patientId
 */
TenantSmsMessage.prototype.patientId = undefined;

/**
 * @member {String} patientName
 */
TenantSmsMessage.prototype.patientName = undefined;

/**
 * @member {String} referredPatientId
 */
TenantSmsMessage.prototype.referredPatientId = undefined;

/**
 * @member {String} referredPatientName
 */
TenantSmsMessage.prototype.referredPatientName = undefined;

/**
 * @member {Date} enrolledDate
 */
TenantSmsMessage.prototype.enrolledDate = undefined;
